<template>
    <the-nav-dialog-layout ref="dialog" v-slot="{ type }" title="公共设置" :navs="navs">
        <component :is="type"></component>
    </the-nav-dialog-layout>
</template>
<script>
import BasicConfig from '@/components/desk-header/components/configs/basic-config';
import EmailConfig from '@/components/desk-header/components/configs/email-config';
import LbsConfig from '@/components/desk-header/components/configs/lbs-config';
import MsgConfig from '@/components/desk-header/components/configs/msg-config';
import SmsConfig from '@/components/desk-header/components/configs/sms-config';
import WeatherConfig from '@/components/desk-header/components/configs/weather-config';
import TheNavDialogLayout from '@/components/desk-header/components/the-nav-dialog-layout';

const defaultType = 'BasicConfig';
const navs = Object.freeze([
    ['BasicConfig', '基础配置'],
    ['EmailConfig', '邮箱配置'],
    ['SmsConfig', '短信配置'],
    ['WeatherConfig', '天气服务'],
    ['LbsConfig', 'LBS API 配置'],
    ['MsgConfig', '消息服务']
]);

export default {
    name: 'TheCommonSettingsDialog',
    components: {
        TheNavDialogLayout,
        WeatherConfig,
        SmsConfig,
        MsgConfig,
        LbsConfig,
        EmailConfig,
        BasicConfig
    },

    data() {
        return {
            navs
        };
    },

    methods: {
        open(type = defaultType) {
            this.$refs.dialog.open(type);
        }
    }
};
</script>

<style lang="scss" scoped>
.common-settings-wrapper {
    .page {
        height: 800px;
        box-shadow: 0px 2px 4px 0px rgba(230, 180, 180, 0.2);
        border-radius: 2px;
    }

    ::v-deep {
        .isc-dialog {
            padding: 0;

            &__body {
                padding: 0;
            }
        }
    }
}
</style>
